import { MutableRefObject } from "react";
import Button from "@/elements/Shared/Button";
import buttonProps from "@/interfaces/DataButtonProps";

export default function renderButton(
  button: buttonProps,
  sectionName: string,
  isHero: boolean,
  buttonRef: MutableRefObject<any>
) {
  switch (button?.type) {
    case "button":
      if (isHero) {
        return (
          <Button
            isVisibleOnMobile={button.isVisibleOnMobile}
            path={button?.link}
            bg={button?.styles?.bg}
            border={button?.styles?.border}
            color={button?.styles?.color}
            icon={button?.styles?.icon}
            className="hero-button btn-3d-flip"
            buttonRef={buttonRef}
          >
            {button?.text}
          </Button>
        );
      }
      return (
        <Button
          isVisibleOnMobile={button.isVisibleOnMobile}
          path={button?.link}
          bg={button?.styles?.bg}
          border={button?.styles?.border}
          color={button?.styles?.color}
          icon={button?.styles?.icon}
          className={sectionName + "-button" + " btn-3d-flip"}
          buttonRef={buttonRef}
        >
          {button?.text}
        </Button>
      );
    case "link":
      return (
        <Button
          isVisibleOnMobile={button.isVisibleOnMobile}
          path={button.link}
          isLink={true}
          className={sectionName + "-button"}
          buttonRef={buttonRef}
        >
          {button?.text}
        </Button>
      );
    case "none":
    default:
      return null;
  }
}
